import React, { Component } from 'react';
import FadeIn from 'react-fade-in';

import './Home.css';

// Importing Components
import Header from '../components/Header';
import Footer from '../components/Footer';

// Importing Project Card Components
import CardA from '../components/CardA';
import CardB from '../components/CardB';
import CardC from '../components/CardC';
import CardD from '../components/CardD';

// Importing Images
import ProfilePicture from '../images/profile.jpg';
import PythonLogo from '../images/python.png';
import DjangoLogo from '../images/django.png';
import JavaScriptLogo from '../images/javascript.png';
import ReactLogo from '../images/react.png';
import PytestLogo from '../images/pytest.png';
import ReduxLogo from '../images/redux.png';
import jestLogo from '../images/jest.png';
import HTMLLogo from '../images/html.png';
import CSSLogo from '../images/css.png';
import DockerLogo from '../images/docker.png';
import FlaskLogo from '../images/flask.png';
import herokuLogo from '../images/heroku.jpg';
import netlifyLogo from '../images/netlify.png';
import webpackLogo from '../images/webpack.png';
import babelLogo from '../images/babel.png';



class Home extends Component {
    render() {
        return (
            <div className="Home">
                <Header></Header>


                {/* _____ ABOUT Section _____ */}
                <FadeIn delay={1500} transitionDuration={1000}>
                    <div className="section-header" id="about">
                        <i class="fa fa-2x fa-diamond"><b>&nbsp;About</b></i><br/>
                        <div className="section-line"></div>
                    </div>
                </FadeIn><br/>
                <div className="about">
                    <FadeIn delay={1500} transitionDuration={2000}>
                        <div className="about-dp"><img src={ProfilePicture} alt="Fops"/></div>
                    </FadeIn>
                    <FadeIn delay={2250} transitionDuration={2000}>
                        <div className="about-dtl-p">
                                <p>Fullstack Junior Software Engineer</p>
                        </div>
                    </FadeIn>
                </div>
                <div className="about-dtl-p">
                <p> Welcome to my Digital Portfolio, I hope this peaks your interest enough to look more into my profile.
            </p>
            <br></br>
            <p> I have acquired a particular set of skills during my time training to be a Software engineer, scroll down a bit to see them! I've got a weird love for testing Frontends (one thing most developers hate!) and Building Beautiful Frontends in React. </p>
            <br></br>
            <p>Life comes at you fast, slow it down whilst you browse through this site</p>
            <br></br>
            <p> 'Be the head and not the tail'</p> 
               <p id= 'italic'> - Fope, 2000 </p>
            <br /><br /><br />
            </div>
                {/* _____ ABOUT Section end _____ */}

                {/* _____ PROJECTS Section _____ */}
                <FadeIn delay={3000} transitionDuration={1000}>
                    <div className="section-header" id="projects">
                        <i class="fa fa-2x fa-diamond"><b>&nbsp;Projects</b></i><br/>
                        <div className="section-line"></div>
                    </div>
                </FadeIn><br/>
                <FadeIn delay={3000} transitionDuration={2000}>
                    <div className="projects-tab">
                        <div className="tab-block">
                            <CardA></CardA> &nbsp;
                            <CardB></CardB> &nbsp;
                        </div><br/>
                        <div className="tab-block">
                            <CardC></CardC> &nbsp;
                            <CardD></CardD> &nbsp;
                        </div><br />
                    </div><br />
                </FadeIn><br /><br />
                {/* _____ PROJECTS Section end _____ */}


                {/* _____ SKILLS Section _____ */}
                <FadeIn delay={3000} transitionDuration={1000}>
                    <div className="section-header" id="projects">
                        <i class="fa fa-2x fa-diamond"><b>&nbsp;Skills</b></i><br/>
                        <div className="section-line"></div><br/>
                        <div className="skills-lang">
                            <img src={PythonLogo} alt="Python" /> &nbsp; 
                            <img src={DjangoLogo} alt="Django" /> &nbsp; 
                            <img src={JavaScriptLogo} alt="JavaScript" /> &nbsp; 
                            <img src={ReactLogo} alt="React" /> &nbsp; 
                            <img src={PytestLogo} alt="Pytest" /> &nbsp; 
                            <img src={ReduxLogo} alt="Redux" /> &nbsp; 
                            <img src={jestLogo} alt="jest" /> &nbsp; 
                            <img src={HTMLLogo} alt="HTM5" /> &nbsp; 
                            <img src={CSSLogo} alt="CSS3" /> &nbsp; 
                            <img src={DockerLogo} alt="docker" /> &nbsp; 
                            <img src={FlaskLogo} alt="flask" /> &nbsp; 
                            <img src={herokuLogo} alt="heroku" /> &nbsp; 
                            <img src={netlifyLogo} alt="Netlify" /> &nbsp;
                            <img src={webpackLogo} alt="Webpack" /> &nbsp;
                            <img src={babelLogo} alt="Babel" /> &nbsp;
                            <img src={jestLogo} alt="Jest" /> &nbsp;


                        </div><br />
                    </div>
                </FadeIn><br/><br /><br />
                {/* _____ SKILLS Section end _____ */}


                {/* _____ CONTACT Section _____ */}
                <FadeIn delay={3000} transitionDuration={1000}>
                    <div id="contact"><Footer></Footer></div>
                </FadeIn>
                {/* _____ CONTACT Section end _____ */}


            </div>
        );
    }
}

export default Home;
